import { motion } from "framer-motion";

export const FooterSection = () => (
  <motion.section
    className="sec snap-sec"
    data-testid="footer-section"
    style={{ paddingBottom: 90 }}
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 1 }}
  >
    <div className="foot-bless f-corm">We await your presence &amp; blessings</div>
    <div className="foot-names f-corm">Nikhil Ahuja &amp; Parita Jagad</div>
    <div className="eyebrow f-corm" style={{ marginTop: 8 }}>Ahuja &amp; Jagad Families</div>
    <img src="/assets/couple.png" alt="Nikhil Ahuja and Parita Jagad" className="foot-couple" />
  </motion.section>
);
